<template>
  <div class="container">
    <div class="header">
      <p style="color:#526069;font-size: 18px">待交发票</p>
      <el-button
        type="primary"
        style="height: 35px;width: 126px;line-height: 10px;color: #fff;"
        @click="exportExcel"
      >导出报表</el-button>
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="text-align: left;">
      <el-form-item label="店铺名称:">
        <el-input class="ein" v-model="formInline.user" placeholder="请输入店铺名称"></el-input>
      </el-form-item>

      <el-form-item class="efi" label="结算周期:">
        <el-select class="ein" v-model="rateIndex" placeholder="请选择提现模板">
          <el-option
            v-for="(item,index) in feeRates"
            :label="'T+'+item.day+' '+item.feeRate*100+'%'"
            :value="index"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="header">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        style="text-align: left;"
      >
        <el-form-item label="时间范围:">
          <el-col :span="11">
            <el-date-picker
              :clearable="false"
              type="date"
              placeholder="选择查询起始时间"
              v-model="formInline.date1"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
          <el-col :span="2" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-date-picker
              :clearable="false"
              type="date"
              placeholder="选择查询结束时间"
              v-model="formInline.date2"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <div style="margin-right: 20px;">
        <el-button type="primary" style="height: 35px;line-height: 10px;" @click="getList(1)">查询</el-button>
        <el-button type="info" style="height: 35px;line-height: 10px;" @click="reset">重置</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      stripe
      :row-style="row"
      :header-cell-style="cell"
      style="width: 100%;"
    >
      <el-table-column align="center" prop="name" label="店铺名称" width="120"></el-table-column>
      <el-table-column
        align="center"
        prop="examineTime"
        :formatter="dateFormat"
        label="提现时间"
        width="100"
      ></el-table-column>
      <el-table-column align="center" prop="withdrawable" label="当前可提现金额" width="160"></el-table-column>
      <el-table-column align="center" prop="source" label="提现金额渠道" width="180"></el-table-column>

      <el-table-column align="center" prop="amount" :formatter="toFixed" label="本次提现金额"></el-table-column>
      <el-table-column
        align="center"
        prop="successCashAmount"
        :formatter="toFixed"
        :render-header="renderHeaderOne"
        label="待转账金额"
      ></el-table-column>
      <el-table-column
        align="center"
        width="160"
        prop="invoiceAmount"
        :formatter="toFixed"
        :render-header="renderHeaderTurn"
        label="待交发票金额"
      ></el-table-column>
      <el-table-column align="center" prop="balance" :formatter="toFixed" label="钱包余额"></el-table-column>
      <el-table-column align="center" prop="feeRate" :formatter="tempFormat" label="提现周期"></el-table-column>
      <el-table-column align="center" label="操作" style="text-align: center;">
        <template slot-scope="scope">
          <el-button @click="ensurePress(scope.row.orderId)" type="text" size="small">确认已收到发票</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagi"
      background
      layout="prev, pager, next,jumper"
      :total="total"
      @current-change="getList"
    ></el-pagination>
  </div>
</template>

<script>
import { getFeeRate, getWaitBillList, ensureGetBill } from "@/api/finance";
import { compareTime } from "@/utils";
import { downloadExcel } from "@/utils/downloadFetch";
import {shop_url} from '@/global';
export default {
  name: "",
  props: [""],
  data() {
    return {
      formInline: {
        user: "",
        feeRate: "",
        day: "",
        type: "",
        date1: "",
        date2: ""
      },
      rateIndex: "",
      tableData: [],
      feeRates: [],
      total: 0,
      page: 1,
      pageSize: 10,
      currentData: ""
    };
  },
  mounted() {
    this.getFeeRates();
    this.getList(1);
  },
  methods: {
    cell() {
      return {
        textAlign: "center",
        color: "#526069",
        fontSize: "14px"
      };
    },
    row() {
      return {
        height: "36px",
        textAlign: "center",
        color: "#7d8893",
        fontSize: "14px"
      };
    },
    getFeeRates() {
      getFeeRate().then(res => {
        this.feeRates = res.data.data;
      });
    },
    getList(page) {
      this.page = page;
      if (this.rateIndex) {
        let { day, feeRate } = this.feeRates[this.rateIndex];
        this.formInline.day = day;
        this.formInline.feeRate = feeRate;
      }
      let { date1, date2 } = this.formInline;
      let flag = compareTime(date1, date2);
      if (flag) {
        getWaitBillList(this.formInline, this.page, this.pageSize).then(res => {
          console.log(res);
          this.tableData = res.data.list;
          this.total = parseInt(res.data.count);
        });
      } else {
        this.$notify({
          title: "提示",
          message: "请正确选择时间",
          type: "warning",
          duration: 800
        });
      }
    },
    /* 导出报表 */
    exportExcel() {
      this.formInline.status = "102"; //倒出报表时需要的一个属性
      if (this.rateIndex) {
        let { day, feeRate } = this.feeRates[this.rateIndex];
        this.formInline.day = day;
        this.formInline.feeRate = feeRate;
      }
      let { date1, date2 } = this.formInline;
      let flag = compareTime(date1, date2);
      if (flag) {
        this.formInline.start = date1;
        this.formInline.end = date2;
        downloadExcel({
          method: "post",
          fileName: "商户交易数据报表.xls",
          url: `${shop_url}/shop/cms/print/withdraw`,
          data: this.formInline
        }).then(res => {
          console.log(res);
        });
      }
    },
    reset() {
      this.formInline = {
        user: "",
        feeRate: "",
        day: "",
        type: "",
        date1: "",
        date2: ""
      };
      this.rateIndex = "";
    },
    dateFormat(row, column) {
      return this.uwsToDate(row[column.property]);
    },
    renderHeaderOne(h, { column, $index }) {
      console.log("in render");
      return h("div", [
        h("span", column.label),
        h(
          "el-tooltip",
          [
            h("i", {
              class: "el-icon-warning",
              style: "color:#409eff;margin-left:5px;"
            }),
            h(
              "p",
              {
                slot: "content",
                placement: "right-end"
              },
              "待转账金额 = 本次提现金额 - 手续费"
            )
          ],
          {
            placement: "right-end"
          }
        )
      ]);
    },
    renderHeaderTurn(h, { column, $index }) {
      console.log("in render");
      return h("div", [
        h("span", column.label),
        h(
          "el-tooltip",
          [
            h("i", {
              class: "el-icon-warning",
              style: "color:#409eff;margin-left:5px;"
            }),
            h(
              "p",
              {
                slot: "content",
                placement: "right-end"
              },
              "消费者使用润泽钱包支付的金额商家提现时需要提供发票"
            )
          ],
          {
            placement: "right-end"
          }
        )
      ]);
    },
    tempFormat(row, column) {
      let day = row.day;
      let tpl = row[column.property];
      return "T+" + day + " " + tpl * 100 + "%";
    },
    ensurePress(id) {
      this.$confirm("请确认已收到发票?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.ensure(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    ensure(id) {
      ensureGetBill(2, id).then(res => {
        if (res.status == 200) {
          this.$message({
            type: "success",
            message: "确认成功!"
          });
          this.getList(1);
        }
      });
    }
  }
};
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 30px;
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  justify-content: space-between;
}
.el-input {
  border-bottom: 240px #d1dee1;
}
.ein {
  width: 240px;
}
.efi {
  margin-left: 50px;
}
.pagi {
  align-self: center;
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance/Bill.vue